/**
 * created by tian ruo jun
 * 2022/04/15
 * 稿件编辑器
 * 用于打开投稿稿件即1.0版本稿件，1、从新闻投稿直接写稿的就是投稿稿件了；2、投稿稿件在提交至素材中心之前一直都是投稿稿件，提交至素材中心后会创建1.1版本
 */
import React, {Component} from 'react';
import {Button, Input, message, Modal} from "antd";
import Editor from '../Editor'
import EditorInformation from '../components/EditorInformation'
import ButtonList from "../components/activitiAndBtn/ButtonList";
import EditorPublishInformation from "../components/EditorPublishInformation";
import BaseComponent from "../../../base/BaseComponent";
import {informationConfig, formItemSizeConfig} from "./form/information-config";
import {publishInformationConfig} from "./publish/publishInformation-config";
import {base64Encode} from "../../../utils";
import {getInfoFromLocalStorage} from "../../../actions";
import {removeContentSecurity} from "../floatTool/securityCheck";
import SyncModal from "../../../view/components/syncModal/syncModal";
import LinkCheck from "../components/pluginsSpace/linkCheck/linkCheck";
import {systemBaseEvent} from "../../../base/baseEvent";
import DiscardReason from '../components/discardReason/discardReason';
const {TextArea} = Input;

const topBtnHeight = 64;//顶部按钮高度
const tqs = "";

const storyStatus = {
    "投稿成功成功": "投稿成功"
};

export default class StoryEditor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,//稿件id和uuid
            contentText: "",//稿件内容
            activityOption: {},// 审核流所需参数
            informationStatus: false,//基本信息的展开状态
            publishSettingStatus: true, //右侧展开状态
            showRemarks: false,
            remarks:"",
            isLockedData:{},//锁住的信息
            isDelete: false,
            discardReasonList: [
                { key: 1, value: 1, label: '文字问题' },
                { key: 2, value: 2, label: '格式问题' },
                { key: 3, value: 3, label: '图片问题' },
                { key: 4, value: 4, label: '链接问题' },
            ]
        };
        window.ueditor.dataType = "story";
        window.ueditor.setCurrentInformation = (data) => {
            this.setCurrentInformation(data);
        };
        if(this.state.id){
            systemBaseEvent.syncPlaybackExec("editorUpdateData");//广播编辑器中当前是修改稿件
        }
        systemBaseEvent.syncPlaybackExec("editorIdChange", {editorId: this.props.id});//广播编辑器中的当前id
        systemBaseEvent.syncPlaybackExec("editorAjaxShowDataUrlChange", "/cm-sites-pms/story/show?storyId=");//广播ajax获取数据的方式
    }

    activitiBtns;
    storyData={};

    componentWillMount() {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        this.state.id = id;
        if (!id) {
            this.initActivitiConfig({});
        }
    }

    /**
     * 设置父页面传过来的参数作为编辑器中的数据回显
     */
    initParentData() {
        if (this.urlParams && this.urlParams.storyId) {
            this.state.storyId = this.urlParams.storyId;
            systemBaseEvent.syncPlaybackExec("editorIdChange", {editorId: this.urlParams.storyId});
            this.setState({});
        }
    }
    pojoName = 'tggj';
    beforeInitActivitiConfig = (story,call) => {
        if(this.state.id && story.id === this.state.id) {
            this.request({
                url: `/cm-sites-pms/story/findStorySource?storyId=${this.state.id}`,
                callBack: (res) => {
                    if(res) {
                        call&&call({
                            showBtnFlag: false
                        })
                    } else {
                        call&&call()
                    }
                },
                errorCallBack: (e) =>{
                    console.log(e.toString())
                    call&&call()
                }
            })
        } else {
            call&&call()
        }
    }
    /**设置流程配置*/
    initActivitiConfig(story) {
        this.beforeInitActivitiConfig(story,(config)=> {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";

        // 判断操作权限start
        let showBtnFlag = false;
        let mediaId = story && story.mediaId ? story.mediaId : "";
        if (mediaId) {
            let menu = getInfoFromLocalStorage("menu");
            let publishMenu = menu.find(item => item.menuCode == "mediaPublish");
            if (publishMenu && publishMenu.child && publishMenu.child.length) {
                if (publishMenu.child.find(item => item.menuCode == mediaId)) {
                    showBtnFlag = true;
                }
            }
        } else {
            showBtnFlag = true;
        }
        if(config?.showBtnFlag === false) {
                showBtnFlag = false;
            }
        let pojoName = this.pojoName || 'tggj';
        // if(this.urlParams && this.urlParams.activitiConfName && this.urlParams.activitiConfName.indexOf("sczxwxlc")>-1) {
        //     pojoName = 'likeWechat'
        // }
        let activitiConf = this.urlParams ? {type: this.urlParams.activitiConfName} : null;
        let againFlag = false;
        // 如果草稿稿件可以被创建人之外的人看到，则需要手动控制审核流不要重启
        if(story && story.statusName === "草稿" && story.submitter !== userId) {
            // 当稿件状态为草稿时，审核流会自动重启，此时将activitiConf置空则审核流不重启
            activitiConf = null
        }
        // 判断操作权限end
        this.state.activityOption = {
            ...this.state.activityOption,
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: pojoName,//数据表name
            userAccount: account,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {},//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                /**
                 * 新闻投稿提交至媒体前置js，判断是否有流程推进备选人
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                preCheckCandidate: (activiti, buttonConf, call) => {
                    // let publishData = that.getPublish();
                    let publishData = that.getPublishDetails();
                    let {synchronousContribute = []} = publishData;
                    // 推进流程的时候，投递栏目必填
                    if (!(synchronousContribute && synchronousContribute.length)) {
                        window.loading.hide();
                        message.destroy();
                        return message.warning("未选择投递媒体或部门")
                    }
                    let getErrorFun= (meg)=>{
                        window.loading.hide();
                        message.destroy();
                        message.warning(meg || "未查到媒体候选人！");
                    };
                    let checkDept = (users, hasPermissionsUsers,mediaIds,depts,callback) => {
                        users.forEach(user=>{
                            if(hasPermissionsUsers.some(item=>item.deptIds[0]===user.deptId && user.userId === item.id)) {
                                depts = depts.filter(dept=>dept.id!==user.deptId)
                            }
                        });
                        callback(depts)
                    };
                    let getUserByPermissions = (users,mediaIds,depts) => {
                        // 过滤拥有收稿权限的用户
                        that.getUserByPermissions(["received_story"], (hasPermissionsUsers) => {
                            if (hasPermissionsUsers && hasPermissionsUsers.length) {
                                // 先查询是否有满足条件的人
                                let hasCondition  = users.some(item1 => hasPermissionsUsers.some(item2 => item1.deptId === item2.deptIds[0] && item1.userId === item2.id));
                                if (hasCondition) {
                                    // 查询是否有某部门没有收稿条件
                                    checkDept(users, hasPermissionsUsers, mediaIds ,depts, (pass)=>{
                                        if(pass?.length) {
                                            let names = pass.map(p=>p.name);
                                            window.loading.hide();
                                            Modal.confirm({
                                                title: `以下部门未查到收稿人，是否继续提交？`,
                                                content: `${names.join("，")}`,
                                                onOk() {
                                                    window.loading.show();
                                                    call({code: 1, log: "查询到了媒体候选人！"})
                                                },
                                                onCancel() {
                                                    console.log('Cancel');
                                                },
                                            });
                                            return false
                                        }
                                        call({code: 1, log: "查询到了媒体候选人！"})
                                    });
                                } else {
                                    getErrorFun("未查到拥有所投递媒体收稿权限的用户")
                                }
                            } else {
                                getErrorFun("未查到拥有收稿权限的用户")
                            }
                        });
                    };
                    let {mediaIds, depts} = that.getInfoBySynchronousContribute(synchronousContribute);
                    if(mediaIds?.length) {
                        // 非选部门形式（投稿形式）
                        // 过滤拥有媒体权限的用户
                        that.getAccessUserByMediaIds(mediaIds, (users)=>{
                            if(users && users.length) {
                                getUserByPermissions(users,mediaIds,depts)
                            } else {
                                getErrorFun("未查到所投媒体管理员，请配置媒体管理员后重试")
                            }
                        });
                    } else if(depts?.length) {
                        // 纯选择部门形式
                        that.getAccessUserByDeptIds(depts.map(d=>d.id), (users)=>{
                            if(users && users.length) {
                                getUserByPermissions(users,mediaIds,depts)
                            } else {
                                getErrorFun("未查到所投媒体管理员，请配置媒体管理员后重试")
                            }
                        });
                    } else {
                        getErrorFun("未查到所投媒体管理员，请配置媒体管理员后重试")
                    }
                },
                callActRevert: (activiti, buttonConf, call) => {
                    activiti.terminate.call(activiti, (res) => {
                        if (res) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res.status) {
                                    activiti.successMsg("流程已撤回，稿件变为草稿状态", function () {
                                        activiti.submitOK.call(activiti);
                                    });
                                }
                            })
                        }
                    });
                },
                /**
                 * 修改完成后直接提交给返回的人 不经过中间审核
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callAgent: function (activiti, buttonConf, call) {
                    let uuid = activiti.options.uuid;
                    that.request({
                        url: "/cm-sites-sys/process/getProcessHistory",
                        method: "post",
                        body: {bizKey: uuid},
                        callBack: (data) => {
                            var historyList = data;
                            if (historyList && historyList.length > 1 && historyList[0].candidateInfo && historyList[0].candidateInfo.length) {
                                var callBackHistory = historyList[0];
                                activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                    id: callBackHistory.operatorUserInfo.userId,
                                    name: callBackHistory.operatorName,
                                    deptId:  callBackHistory.operatorUserInfo.deptId,
                                }];
                                call({code: 1, log: "查询到返回者为：" + callBackHistory.candidateNames[0]});
                            } else {
                                call({code: -1, msg: "未查询到返回者！"})
                            }
                        },
                        errorCallBack: () => {
                            message.error("未查询到返回者！");
                            window.loading.hide();
                        },
                    });
                },
            },//流程按钮点击事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            mustNotShowPublishBtn: true, // 投稿编辑器中永远不显示发布按钮
            btnLoadOver: (btns) => {
                this.activitiBtns = btns;
                this.setState({});
            },
            showBtnIcon: true,
            showLockCall: (data) => {
                // data={status: true, id: this.messageId}  true 加锁成功，只有当前人可编辑，  false 加锁失败，不可编辑，
                // 如果加锁失败，则开启遮罩
                if (!data.status) {
                    this.Editor.showLockMask(data);
                    this.state.isLockedData = data;
                    this.setState({})
                }
            },
            btnType: "editor",
            checkForm: that.checkForm,
            successMsg: function (res,duration,call) {
                let msg = res;
                if(res.msg) {
                    msg = res.msg;
                }
                if(msg&&storyStatus[msg]) {
                    msg = storyStatus[msg];
                }
                message.success(msg, 1, call);
            }
        };
        this.setState({},()=>{that.getDiscardReason();});
        })
    }

    getAccessUserByMediaIds = (mediaIds,callBack) => {
        this.request({
            url: "/cm-sites-pms/contribute/getAccessUser",
            method: "post",
            loading:false,
            body: {mediaIds: mediaIds},
            callBack,
            errorCallBack: (e) => {
                callBack&&callBack([])
            },
        })
    };

    getAccessUserByDeptIds = (deptIds,callBack) => {
        this.request({
            url: "/cm-sites-pms/contribute/getAccessUserByDeptIds",
            method: "post",
            loading:false,
            body: {deptIds: deptIds},
            callBack,
            errorCallBack: (e) => {
                callBack&&callBack([])
            },
        })
    };

    getUserByPermissions = (code, callBack) => {
        this.request({
            // url:'/cm-sites-sys/user/getUserByPermissions',
            url:'/cm-sites-sys/user/getUserByPermissionsGroupByDept',
            method:'post',
            // body:code,
            loading:false,
            body: {
                permissionCodes: code,
                size: 9999,
                start: 1
            },
            contentType:"json",
            callBack: (res) => {
                let list = [];
                if(res?.data?.length) {
                    list = res.data.map(item=>({
                        id: item._id,
                        deptIds: item?.deptRoles?.deptId ? [item?.deptRoles?.deptId] : []
                    }))
                }
                callBack&&callBack(list)
            }
        })
    };

    getInfoBySynchronousContribute = (synchronousContribute=[]) => {
        console.log(synchronousContribute);
        let mediaIds = [];
        let depts = [];
        synchronousContribute.forEach(item=>{
            switch (item.type) {
                case "dept":
                    if(depts.every(d=>d.id!==item.id)) {
                        depts.push({name:item.name,id:item.id})
                    }
                    break;
                case "media":
                    if(depts.every(d=>d.id!==item.deptId)) {
                        depts.push({name:item.deptName,id:item.deptId});
                    }
                    if(mediaIds.indexOf(item.id) == -1) {
                        mediaIds.push(item.id);
                    }
                    break;
            }
        });
        return {mediaIds, depts}
    };

    getUserPermissionFromMedia = ({mediaIds, call}) => {
        let userInfo = getInfoFromLocalStorage("currentUser");
        let receivers = {
            deptId: userInfo.defaultInfo.dept.id,
            userId: userInfo.id,
        };
        // 获取拥有当前稿件媒体列表的媒体权限的所有人
        this.request({
            url: "/cm-sites-pms/contribute/getAccessUser",
            method: "post",
            body: {mediaIds:mediaIds.join(",")},
            callBack: (list) => {
                let canDo = false;
                if(list&&list.length) {
                    canDo = list.some(item=>item.deptId===receivers.deptId&&item.userId===receivers.userId)
                }
                call && call(canDo)
            },
            errorCallBack: () => {
                message.error("过滤媒体权限失败,请稍后重试");
                window.loading.hide();
            },
        });
    };

    getActHistoryLength = (uuid) => {
      if(uuid) {
          return new Promise((resolve, reject) => {
              this.request({
                  url: "/cm-sites-activiti/activiti/getActHistory",
                  method: "post",
                  body: {uuid},
                  callBack: (actHistory) => {
                      let actHistoryLength = 0;
                      if(actHistory && Array.isArray(actHistory)) {
                          actHistoryLength = actHistory.length
                      }
                      if(actHistory && !Array.isArray(actHistory) && Array.isArray(actHistory.data)) {
                          actHistoryLength = actHistory.data.length
                      }
                      if(actHistoryLength) {
                          resolve(true)
                      } else {
                          resolve(false)
                      }
                  },
                  errorCallBack: (e) => {
                      resolve(false)
                  },
                  serverVerify:{
                      serverErrorCallBack:(e)=>{
                          resolve(false)
                      },
                      isShowErrorMsg:true
                  },
              })
          })
      } else {
          return false
      }
    };

    refresh = (activiti) => {
        let hash = window.location.hash.split('/');
        if (this.state.id && !(hash[hash.length - 1] && hash[hash.length - 1].length > 1)) {
            hash[hash.length - 1] = this.state.id;
        }
        this.callPostMessage({message: '请求刷新父页面'});
        window.location.hash = hash.join('/');
        // activiti && activiti.load.end();
        window.location.reload();
    };

    componentDidMount() {
    }

    // 渲染稿件编辑器
    render() {
        let that = this;
        return (
            <Editor
                // Editor组件暴露
                ref={(Editor) => {
                    this.Editor = Editor
                }}
                // 动态参数（传递到子组件中）
                dynamicParams={{
                    editorId: this.state.id,
                    oldId:this.state.storyId,
                    // findOldUuid: this.findOldUuid
                }}
                // 流程按钮组件
                editorActBtn={this.renderActBtn()}
                // 稿件基本信息组件
                editorInformation={this.renderInformation()}
                // 稿件栏目设置模块  只有投稿箱的数据才显示右侧信息
                editorRightModule={this.renderEditorPublishInformation()}
                // 编辑器加载完毕的回调
                onEditorLoadOver={() => {
                    window.ueditor.afterSaveDataFun = [];
                    window.ueditor.addAfterSaveDataFun = function (fun) {
                        window.ueditor.afterSaveDataFun.push(fun);
                    };
                    that.getStoryById();
                    //接收参数去渲染数据  这里只能放在这里，因为必须等到编辑器加载完成了之后，才要把内容放在编辑器中
                    that.initParentData();
                }}
                // 编辑器内容改变的回调
                onEditorContentChange={(content) => {
                    this.setState({contentText: this.getEditContentText()})
                }}
                // 基本信息展开和关闭的回调
                onInformationStatusCallBack={(status) => {
                    this.setState({informationStatus: status})
                }}
                // 表单展开状态
                informationStatus={this.state.informationStatus}
                // 右侧展开状态获取稿件
                publishSettingStatus={this.state.publishSettingStatus}
                // 编辑器工具栏上的插件配置
                pluginsSpaceConfig={["securityPlugin","storyResource","storyImport",'storyLayout']}
            />
        )
    }

    getActBtnListData() {
        // 这里不要限制打印按钮
        // if(this.urlParams && this.urlParams.hideBtn){
        //     return null;
        // }
        let {activityOption} = this.state;
        if (!(activityOption && activityOption.pojoName)) {
            return null;
        }
        let that = this;
        // 流程按钮需要的参数
        let buttonListData = {
            topBtnHeight,
            activityOption,
            saveStory: that.saveStory,
            showSave: (() => {
                if (this.activitiBtns && (this.activitiBtns.length > 0)) {
                    let configBtns = this.sysConfigGetValueByKey("story.editor.saveBtn.mutex.activiti.btn", "撤回,返回写稿人").split(",");
                    let result = true;
                    this.activitiBtns && this.activitiBtns.map(item => {
                        if (configBtns.indexOf(item.name) > -1) {
                            result = false;
                        }
                    });
                    return result;
                }
                return false;
            })(),
            showPreview: false,
            showPrint: true,
            showRemarks: this.state.showRemarks,
            showRemarksCall: this.showRemarksCall,
            showReason: this.state.showReason,
            showDiscardReasonCall: this.showDiscardReasonCall,
            printCall:this.printCall,

        };
        if ((this.urlParams && this.urlParams.hideBtn) || this.state.isDelete ) {
            buttonListData.activityOption.showBtnFlag = false;
            buttonListData.showPreview = false;
        }
		//删除稿件按钮显示控制
        if(this.state.isDelete) {
            buttonListData.showPrint = false;
            buttonListData.showSave = false;
            buttonListData.showRemarks = false;
        }
        return buttonListData;
    };

    //渲染流程按钮
    renderActBtn = () => {
        let buttonListData = this.getActBtnListData();
        let isLockedData={isLockedData:this.state.isLockedData};
        return (
            buttonListData ?
                <>
                    <ButtonList {...buttonListData}{...isLockedData}/>
                    <SyncModal ref={ref => this.syncModal = ref} />
                    <SyncModal ref={ref => this.syncModal2 = ref}/>
                    <LinkCheck ref={ref=>this.LinkCheck=ref}/>
                </> : <></>
        )
    };

    // 打印回调
    printCall = () => {
        let story = this.storyData;
        if(!this.state.id && !(story && story.title)) return message.warning('请先保存，再打印');
        if(!this.state.id) {
            window.openPage({
                url: "/cm-sites/pms/printHtmlDetail.html",
                params: story,
            });
        } else {
            let url = this.toCode("/cm-sites-pms/story/show?storyId="+this.state.id);
            let printUrl='/cm-sites/pms/printHtmlDetail.html?url='+url; // +'&download=true' 直接下载
            window.open(printUrl)
        }
    };
    // 字符串加密
    toCode (str) {
        //定义密钥，36个字母和数字
        var key = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var len = key.length;  //获取密钥的长度
        var a = key.split("");  //把密钥字符串转换为字符数组
        var s = "",b, b1, b2, b3;  //定义临时变量
        for (var i = 0; i <str.length; i ++) {  //遍历字符串
            b = str.charCodeAt(i);  //逐个提取每个字符，并获取Unicode编码值
            b1 = b % len;  //求Unicode编码值得余数
            b = (b - b1) / len;  //求最大倍数
            b2 = b % len;  //求最大倍数的于是
            b = (b - b2) / len;  //求最大倍数
            b3 = b % len;  //求最大倍数的余数
            s += a[b3] + a[b2] + a[b1];  //根据余数值映射到密钥中对应下标位置的字符
        }
        return s;  //返回这些映射的字符
    }

    // 点击查看回调编辑
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onOk: () => {
                that.syncModal.destroy();
            },
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    };

    extractDeptIds(data) {
        let deptIds = [];

        // 递归函数
        function extractIdsRecursive(obj) {
            if (obj.deptId && !deptIds.includes(obj.deptId)) {
                // 如果对象有deptId，并且数组中不存在该deptId，则将其添加到数组中
                deptIds.push(obj.deptId);
            }
            if (obj.child && obj.child.length > 0) {
                // 如果对象有子项，递归调用函数
                obj.child.forEach(child => extractIdsRecursive(child));
            }
        }

        // 遍历数组中的每个对象
        data.forEach(item => extractIdsRecursive(item));
        return deptIds;
    }
    /**查询弃用原因 */
    getDiscardReason = () => {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        if (!id) {
            return
        }
        let deptIdList = window.currentUser &&  window.currentUser.deptIds&& window.currentUser.deptIds.length? window.currentUser.deptIds:[]
        let deptId =  window.currentUser &&  window.currentUser.defaultInfo && window.currentUser.defaultInfo.dept && window.currentUser.defaultInfo.dept.id ? window.currentUser.defaultInfo.dept.id :''
        let publishData = this.getPublishDetails();
        let {synchronousContribute = []} = publishData;
        let deptIds = this.extractDeptIds(synchronousContribute)
        let params = {
            bizKey: id,
            // deptId:deptIds.join(',')//deptId// deptIdList.join(',')
        }
        this.request({
            url: '/cm-sites-pms/contributeRecord/showDeprecatedNotes',// /cm-sites-sys/process/showDeprecatedNotes
            method: 'POST',
            body: params,
            callBack: (res) => {
                if (res.length) {
                    this.setState({
                        showReason: true,
                        reasonRemarks: res[0] && res[0].remarks,
                        remarksList:res,
                    })
                }
            }
        })
    }

    //查看弃用原因
    showDiscardReasonCall = () => {
        let that = this
        const { remarksList, reasonRemarks } = this.state
        let remarks = JSON.parse(reasonRemarks)
        remarks.forEach(item => {
            const matchReason = this.state.discardReasonList.find(reason => reason.value === item.type);
            if (matchReason) {
                matchReason.text = item.value;
            }
        });
        this.setState({}, () => { that.showDiscardReason() })

        ////////////////////////////////////////////////多个弃用原因展示 暂时不存在
        // if (remarksList.length&&remarksList.length===1) {
        //     remarksList.forEach(item => {
        //         remarks = JSON.parse(item.remarks)
        //     })
        //     remarks.forEach(item => {
        //         // 在 discardReasonList 中查找与当前元素的 type 相匹配的项
        //         const matchReason = this.state.discardReasonList.find(reason => reason.value === item.type);
        //         // 如果找到匹配的项，则将当前元素的 value 赋值给匹配项的 text
        //         if (matchReason) {
        //             matchReason.text = item.value;
        //         }
        //     });
        //     this.setState({},()=>{that.showDiscardReason()})
        // } else if(remarksList.length>1) {
        //     that.syncModal.confirm({
        //         title: "查看原因",
        //         width: 400,
        //         content: <div>
        //             {remarksList.length > 1 ? remarksList.map(item => (<div>
        //                 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        //                     <span>{item.deptName}</span>
        //                     <span onClick={() => {
        //                         let remarksData = JSON.parse(item.remarks)
        //                         // 遍历 remarksList 中的每个元素
        //                         remarksData.forEach(item => {
        //                             // 在 discardReasonList 中查找与当前元素的 type 相匹配的项
        //                             const matchReason = this.state.discardReasonList.find(reason => reason.value === item.type);
        //                             // 如果找到匹配的项，则将当前元素的 value 赋值给匹配项的 text
        //                             if (matchReason) {
        //                                 matchReason.text = item.value;
        //                             }
        //                         });
        //                         this.setState({
        //                         },()=>{
        //                             that.showDiscardReason()
        //                         })
        //                     }}>查看原因</span>
        //                 </div>
        //             </div>)):null}
        //         </div>,
        //         okText: "确定",
        //         cancelText: "取消",
        //         footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
        //         onOk: () => {
        //             that.syncModal.destroy();
        //         },
        //         onCancel: () => {
        //             that.syncModal.destroy();
        //         }
        //     });
        // }

    }

    showDiscardReason = () => {
        let that = this;
        that.syncModal2.confirm({
            title: "弃用原因",
            width:400,
            content:<div>
                {that.state.discardReasonList.map((item, index) => (
                    <DiscardReason isEdit={false} data={item}/>
                ))}
            </div>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal2.destroy();}}>关闭</Button>,
            onOk: ()=>{
                that.syncModal2.destroy();
            },
            onCancel: ()=>{
                that.syncModal2.destroy();
            }
        });
    }

    // 渲染稿件基本信息
    renderInformation = () => {
        return (
            <EditorInformation
                // 配置文件
                informationConfig={informationConfig}
                // 配置文件
                formItemSizeConfig={formItemSizeConfig}
                // 基本信息展开状态
                informationStatus={this.state.informationStatus}
                // 编辑器内容
                contentText={this.state.contentText}
                dynamicParams={{
                    editorId: this.state.id,
                }}
                formItemOnChange={(key, value)=>{//表单内容变化时通知
                    systemBaseEvent.asyncExec("editorInformationItemChange", {key, value});
                }}
                // 点击标题的加号
                titleAddOrMinus={(call) => {
                    this.titleAddOrMinus(call)
                }}
                ref={(EditorInformation) => {
                    this.EditorInformation = EditorInformation;
                    window.ueditor.getInformation = (check) => this.EditorInformation.getInformation(check);
                    window.ueditor.delAttachByMd5 = (md5) => this.EditorInformation.delAttachByMd5(md5);
                    window.ueditor.setFocus = (labelKey) => this.EditorInformation.setFocus(labelKey);
                    window.ueditor.informationSelect = (labelKey,sIndex,eIndex) => this.EditorInformation.selectText(labelKey,sIndex,eIndex);
                }}
            />
        )
    };

    // 渲染稿件栏目模块
    renderEditorPublishInformation = () => {
        return (
            <EditorPublishInformation
                ref={(ref) => {
                    this.editorPublishInformation = ref
                }}
                dynamicParams={{storyId:this.state.id}}
                title={'投稿设置'}
                informationConfig={publishInformationConfig}
            />
        )
    };

    titleAddOrMinus(call) {
        this.setState({
            informationStatus: true,
        },()=>{
            call&&call(true)
        })
    }

    canDo = false;
    // 判定前端采用弃用拾取按钮的权限
    getCanDo = () => {
        let mediaIds = this.storyData && this.storyData.mediaIds;
        if(mediaIds) {
            this.getUserPermissionFromMedia({
                mediaIds, call: (canDo) => {
                    if(canDo) {
                        this.canDo = true;
                    }
                    this.setState({})
                }
            })
        }
    };

    /**
     * 获取稿件
     */
    getStoryById = () => {
        let that = this;
        if (!(this.state.id && this.state.id.length > 1 && this.state.id != 'null' && this.state.id != 'undefined')) {
            this.Editor&&this.Editor.showData&&this.Editor.showData(this.storyData);
            return;
        }
        this.request({
            url: '/cm-sites-pms/story/show',
            body: {storyId: this.state.id},
            // contentType:'json',
            callBack: function (res) {
                if (res) {
                    systemBaseEvent.syncExec("editorDataChange", res);
                    that.storyData = res;
                    if(res.variableFields?.recycle&&(res.variableFields.recycle ==="1" || res.variableFields.recycle ==="2" )) {
                        that.setState({isDelete:true})
                    }
                    that.setCurrentInformation(res);//回显表单
                    // 重置流程参数
                    that.initActivitiConfig(res);
                    // 回显发布设置
                    that.setPublish({
                        synchronousContribute: res.targetIds,
                        mediaList: res.mediaIds
                    });
                    that.setContent(res.content);//回显编辑器内容
                    // 重置操作权限
                    that.getCanDo();
                    that.Editor&&that.Editor.showData&&that.Editor.showData(that.storyData);

                } else {
                    message.error('该稿件已删除！');
                    that.setState({isDelete:true})
                }
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
                that.setState({isDelete:true})
            }

        });
    };

    checkForm = (activiti, call) => {
        message.destroy();
        //获取编辑器内容=============start
        let content = this.getEditContent();
        if (!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            return false
        }
        if (content.indexOf("wordimg.png") !== -1) {
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            return false
        }
        //获取编辑器内容==================end

        // 获取基础属性==================start
        let currentInformation = this.getCurrentInformation();
        if (!currentInformation) {// 基本信息校验（自带）
            window.loading.hide();
            return false
        }
        if(this.storyData.variableFields){
            currentInformation.variableFields.formatId = this.storyData.variableFields.formatId;
        }
        // let {information, dynamicParams} = currentInformation;
        // 获取基础属性================end

        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';//稿件id
        // 获取发布设置start
        let publishData = this.getPublish();
        let {synchronousContribute = []} = publishData;
        // 推进流程的时候，投递栏目必填
        if (!(synchronousContribute && synchronousContribute.length) && activiti) {
            window.loading.hide();
            message.warning("未选择投递媒体或部门");
            return false
        }
        call&&call()
    };


    /**
     * 稿件保存
     */
    saveStory = (activiti, call) => {
        message.destroy();
        // activiti&&activiti.load.start();
        //获取编辑器内容=============start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            call && call(false);
            return false
        }
        if (content.indexOf("wordimg.png") !== -1) {
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            call && call(false);
            return false
        }
        //获取编辑器内容==================end

        // 获取基础属性==================start
        let currentInformation = this.getCurrentInformation();
        if (!currentInformation) {// 基本信息校验（自带）
            window.loading.hide();
            call && call(false);
            return false
        }
        if(this.storyData.variableFields){
            currentInformation.variableFields.formatId = this.storyData.variableFields.formatId;
        }
        // let {information, dynamicParams} = currentInformation;
        // 获取基础属性================end

        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';//稿件id
        // 获取发布设置start
        let publishData = this.getPublish();
        let {synchronousContribute = []} = publishData;
        // 推进流程的时候，投递栏目必填
        if (!(synchronousContribute && synchronousContribute.length) && activiti) {
            window.loading.hide();
            call && call(false);
            return message.warning("未选择投递媒体或部门")
        }
        let that =this;
        window.loading.hide();
        this.LinkCheck.show(content,(res)=>{
            window.loading.show();
            //content 是替换后的内容     status true 就是全部处理，可直接走流程  false  不走流程，把内容 回填编辑器
            if(res) {
                if(res.content) {
                    this.setContent(res.content);
                }
                if(res.status) {
                    content = base64Encode(removeContentSecurity(res.content || content));
                    let params = {
                        ...that.storyData,
                        ...currentInformation,
                        "content": content,
                        "id": id,
                        "targetIds": synchronousContribute,//投递节点
                        // "title": information.title,
                        // "attach": information.attach,// 附件
                        // "titlePic": information.titlePic,// 主栏目标题图
                        // "variableFields": dynamicParams,// 稿件基本信息
                        // // 站群字段
                        // "wbextends": currentInformation.wbextends,
                    };

                    if(params && !params.id) {
                        systemBaseEvent.syncExec("editorAddData");
                    }else{
                        systemBaseEvent.syncExec("editorUpdateData");
                    }
                    if(this.publishData?.dbUpdateTime) {
                        // 已经保存过，再次进行保存，需要更新保存时间
                        params.dbUpdateTime = this.publishData.dbUpdateTime
                    }
                    this.request({
                        url: '/cm-sites-pms/story/save',
                        method: 'POST',
                        body: params,
                        contentType: 'json',
                        loading:false,
                        callBack: async (res) => {
                            if (res) {
                                // 备注，这里必须这样写，稿件保存时不会回显同步投递的参数，但是发布时需要
                                this.publishData = {...params,...res,content: base64Encode(removeContentSecurity(res.content))};
                                this.state.id = res.id;
                                // window.loading.hide();
                                systemBaseEvent.syncExec("editorDataChange", res);
                                systemBaseEvent.syncExec("editorIdChange", {editorId: this.state.id});
                                let funs = window.ueditor.afterSaveDataFun;
                                for (let i = 0; funs && i < funs.length; i++) {
                                    let fun = funs[i];
                                    if (fun instanceof Promise) {
                                        await fun(activiti, res, call);
                                    } else {
                                        fun(activiti, res, call);
                                    }
                                }
                                this.securityCheckAsyncCheck({params, activiti, story:res, call});
                                this.updateProcessAndData(this.publishData);
                            } else {
                                message.error('保存失败！');
                                call && call(false);
                            }
                        },
                        errorCallBack: function (e) {
                            call && call(false);
                            message.error('保存失败！');
                        },
                        serverVerify: {
                            serverErrorCallBack: (e,allData) => {
                                window.loading.hide();
                                call && call(false);
                            }
                        }
                    });
                } else {
                    window.loading.hide();
                    call && call(false);
                    return false
                }
            }
        });
    };


    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            loading:false,
            body: {
                title: body?.title,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res)=>{

            }
        })
    };

    securityCheckAsyncCheck = ({params, activiti, story, call}) => {
        let that = this;
        // 某些状态不需要检测敏感词start
        let noDetectionStatus = this.sysConfigGetValueByKey("no.detection.story.statusName", "返回,弃用").split(',');
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        // let needDetectionStatus = this.sysConfigGetValueByKey("need.detection.story.statusName", "发布,全部").split(',');
        if (statusNameTemp && noDetectionStatus && noDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1)) {
            call && call(story);
            that.state.id = story.id;
            if (!activiti) {//点击了暂存按钮
                message.success('保存成功！',0.5,()=>{
                    that.refresh()
                });
            }
            return
        }
        // if (!(statusNameTemp && noDetectionStatus && ((needDetectionStatus.indexOf("全部") > -1) || needDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1)))) {
        //     call && call(story);
        //     that.state.id = story.id;
        //     if (!activiti) {//点击了暂存按钮
        //         message.success('保存成功！',0.5,()=>{
        //             that.refresh()
        //         });
        //     }
        //     return false
        // }

        // 某些状态不需要检测敏感词end
        if(this.getNeedCheck(activiti)) {
            if (!window.ueditor.securityCheckAsyncCheck) {
                message.warn("敏感词检测失效，无法进行异步检测");
            } else {
                window.ueditor.securityCheckAsyncCheck((content) => {
                    window.loading.show();
                    call && call(story);
                    that.state.id = story.id;
                    if (!activiti) {//点击了暂存按钮
                        message.success('保存成功！',0.5,()=>{
                            that.refresh()
                        });
                    }
                }).catch(() => {
                    call && call(false);
                    message.error('敏感词检测失败！');
                });
            }
        } else {
            call && call(story);
            that.state.id = story.id;
            if (!activiti) {//点击了暂存按钮
                message.success('保存成功！',0.5,()=>{
                    that.refresh()
                });
            }
            return false
        }
        // 某些状态不需要检测敏感词end

    };
    getNeedCheck = (activiti) => {
        let btnName = activiti?.options?.item?.btnName;
        let name = activiti?.options?.item?.name;
        let statusNameTemp = activiti?.options?.statusNameTemp;
        // 获取需要检测的状态
        let needDetectionStatus = this.sysConfigGetValueByKey("need.detection.story.statusName", "发布").split(',');
        // if (!(
        //     needDetectionStatus &&
        //     ((statusNameTemp && needDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1))
        //         || (needDetectionStatus.indexOf("全部") > -1))
        // )) {
        //     return false
        // }
        if(!needDetectionStatus?.length) {
            return false
        }
        if(!activiti) {
            // 暂存
            return (
                needDetectionStatus.indexOf("暂存") > -1||
                needDetectionStatus.indexOf("保存") > -1
            )
        }
        if(btnName || name || statusNameTemp) {
            return (
                needDetectionStatus.indexOf(btnName) > -1 ||
                needDetectionStatus.indexOf(name) > -1 ||
                needDetectionStatus.indexOf(statusNameTemp) > -1 ||
                needDetectionStatus.indexOf("全部") > -1
            )
        }
        return false
    };
    // 收稿id获取投稿稿件id
    findOldUuid = ({id}) => {
        return new Promise(((resolve, reject) => {
            this.request({
                url: "/cm-sites-pms/story/getContributeStory",
                loading:false,
                body: {storyId:id},
                callBack: (res) => {
                    if(res && res.id) {
                        this.state.storyId=res.id;
                        resolve(res.id)
                    } else {
                        resolve(null)
                    }
                },
                serverVerify:{
                    serverErrorCallBack: ()=>{
                        resolve(null)
                    },
                    isShowErrorMsg:false
                }
            })
        }))
    };

    /**
     * 稿件修改状态
     */
    updateStatusName = (statusName, activiti, call) => {
        let that = this;
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let params = {
            "id": id,
            "statusName": statusName,
        };
        this.request({
            url: '/cm-sites-pms' + tqs + '/story/updateStatusName',
            method: 'POST',
            body: params,
            loading:false,
            callBack: function (res) {
                if (res) {
                    call && call({status: true, msg: "流程推进后状态修改成功。"});
                    // that.state.id=res.id;
                } else {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call && call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    //获取编辑器内容
    getEditContent() {
        let contentTxt = this.getEditContentText();
        let content = window.ueditor.getContent();
        if(
            !(contentTxt && contentTxt.length) &&
            !(content.indexOf("img") > -1 || content.indexOf("IMG") > -1)
        ) {
            return false
        }
        return content
    }

    //获取编辑器内容（文字）
    getEditContentText() {
        return window.ueditor.getContentTxt();
    }

    //设置编辑器内容
    setContent(content) {

        if (content) {

            window.ueditor.setContent(content)
        }
    }

    //获取基本信息
    getCurrentInformation() {
        let editorInformation = this.EditorInformation.getInformation();
        if(editorInformation && typeof editorInformation === "object") {
            editorInformation["category"] = "contribute";
        }
        return editorInformation
    }

    //设置基本信息
    setCurrentInformation(data) {
        this.EditorInformation.setInformation(data)
    }

    /**
     * 右侧栏目的设置与获取方法start
     * */
    setPublish = (data) => {
        this.editorPublishInformation.setData(data)
    };
    getPublish = (data) => {
        return this.editorPublishInformation.getData(data)
    };
    getPublishDetails = (data) => {
        return this.editorPublishInformation.getDetails(data)
    };
    /**
     * 右侧栏目的设置与获取方法end
     * */


}